import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=6fdab6d8&scoped=true&"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=0&id=6fdab6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdab6d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fdab6d8')) {
      api.createRecord('6fdab6d8', component.options)
    } else {
      api.reload('6fdab6d8', component.options)
    }
    module.hot.accept("./AppNavbarVerticalLayout.vue?vue&type=template&id=6fdab6d8&scoped=true&", function () {
      api.rerender('6fdab6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue"
export default component.exports